export default "__VITE_ASSET__BN3zDQ2f__"